import NavigationIcon from "@mui/icons-material/Navigation";
import Fab from "@mui/material/Fab";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Link, useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  collection,
  doc,
  onSnapshot,
  query,
  updateDoc,
  where,
  arrayUnion,
} from "firebase/firestore";

import { db } from "../firebaseConfig.js";
import DestReqCardIndex from "../Commons/destReqCardIndex";
import AppLoader from "../layout/Loading";
import AppSubHeader from "../Commons/appSubHeader";
import NoRecordsFound from "../Commons/NoRecordsFound.js";
import { devConsolelog } from "../Utility.js";
import ReqFilters from "./reqFilters.js";
import {
  BookingTypes,
  BookingStatusCompleted,
  BookingStatusActive,
  BookingStatusCancelled,
  CabTypes,
  DestinationNames,
  BOOKING_CHAT_TYPE_SYSTEM,
  BOOKING_EXPIRE_TIMEOUT_DAYS,
} from "../Constants";

const AdminReqView = ({
  userData,
  reqs,
  setReqs,
  loading,
  getAgentActiveReqs,
  setLoading
}) => {
  const [filteredReqs, setFilteredReqs] = useState([]);
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [bookingDateFilter, setBookingDateFilter] = useState("");
  const initialFilters = {
    bookingStatus: BookingStatusActive,
    // startDate: Date.now(),
    destination: "",
    cabType: "",
    bookingType: "cab",
    trackingId: ""
  }
  const [filters, setFilters] = useState(initialFilters);

  useEffect(() => {
    let unsubscribe = () => {};
    const getReqs = async () => {
      unsubscribe = await getFilterReqs();
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    };
    getReqs();

    return unsubscribe();
  }, [filters]);

  // useEffect(() => {
  //   setFilteredReqs(reqs);
  // }, [reqs]);

  const handleFilterChange = (field, val = "", reset = false) => {
    if(reset) {
      setFilters(initialFilters);
      return;
    }
    if (!field) return;
    if (field == "bookingStatus" && !val) return;
    let filterData = { ...filters };
    filterData[field] = val;
    devConsolelog("admin filter change", field, val, filterData)
    setFilters(filterData);
    // setBookingTypeFilter(val);
  };

  const filtersQuery = () => {
    let { bookingStatus, destination, cabType, trackingId, startDate, endDate } = filters;
    // let queryInitialCondKey = getUserQueryCond();
    devConsolelog("query cond ", bookingStatus, destination, cabType, trackingId, startDate, endDate);
    let qArr = [];
    if (trackingId) {
      qArr.push(where("trackingId", "==", trackingId));
    }
    if (bookingStatus && bookingStatus != "all") {
      qArr.push(where("status", "==", bookingStatus));
    }
    if (destination) {
      qArr.push(where("destination", "==", destination));
    }
    if (cabType) {
      qArr.push(where("cabType", "==", cabType));
    }
    if (startDate) {
      qArr.push(where("startDate", ">=", startDate));
    }
    if (endDate) {
      qArr.push(where("startDate", "<", endDate));
    }

    console.log("admin filtersQuery ", filters, qArr);
    return query(collection(db, "agentRequirements"), ...qArr);
  };

  const getFilterReqs = async () => {
    setLoading(true);
    devConsolelog("admin getFilterReqs")
    // const q = query(
    //   collection(db, "agentRequirements"),
    //   where("status", "==", "active"),
    //   where("agentId", "==", userData.phone)
    //   // orderBy("createdAt", "desc")
    // );

    const q = filtersQuery();

    const unsubscribe = await onSnapshot(
      q,
      async (snapshot) => {
        // if (!snapshot.exists()) return;
        let data = snapshot.docs;
        console.log("admin snapshot", data, snapshot);
        data = await Promise.all(
          data.map(async (i) => {
            // const req = { ...i.data(), id: i.id };
            // const { totalBookings, overallRating } = await fetchAgentStatistics(req.agentId);
            // return { ...req, totalBookings, overallRating };
            return { ...i.data(), id: i.id };
          })
        );

        // setReqs
        setFilteredReqs(
          data.sort(
            (a, b) => Number(b.createdAt || 0) - Number(a.createdAt || 0)
          )
        );

        // checkExpiredReqs(data);
      },
      (error) => {
        console.log("view req error", error);
      }
    );

    return unsubscribe;
  }

  devConsolelog(filters, filteredReqs, "admin req");

  return (
    <>
      {filteredReqs.length >0 && <AppSubHeader name="Requirements" />}
      {loading && <AppLoader />}
      <ReqFilters
        setBookingDateFilter={setBookingDateFilter}
        handleFilterChange={handleFilterChange}
        filters={filters}
        bookingDateFilter={bookingDateFilter}
      />
      <Grid
        container
        spacing={{ xs: 2, md: 2 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        {filteredReqs.length <= 0 && !loading && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto"
            }}
          >
            <NoRecordsFound 
              body={<>
                <Typography variant="body1" sx={{ textAlign: "center", width: "100%", marginTop: 2 }}>
                Post Your First Request
                </Typography>
                <Typography variant="body2" color="primary" sx={{ textAlign: "center", width: "100%" }}>
                No Commision. &nbsp;Multiple B2B Bids.
                </Typography>
                {/* <Typography variant="body2" color="primary" sx={{ textAlign: "center", width: "100%" }}>
                Multiple B2b Bids.
                </Typography> */}
                <Button
                  variant="outlined"
                  size="small"
                  sx={{
                    marginTop: "10px"
                  }}
                  onClick={() => navigate("/post-req")}
                >
                  Click Here
                </Button>
              </>} 
            />

            {/* <Typography variant="h6" sx={{ textAlign: "center", marginTop : 3, width: "100%" }}>
              Post Your First Request
            </Typography>
            <Button
              variant="contained"
              sx={{
                marginTop: "10px"
              }}
              onClick={() => (window.location.href = "/post-req")}
            >
              Click Here
            </Button> */}
          </Box>
        )}

        {filteredReqs.map((req) => {
          let { id = "" } = req;
          return (
            <Grid item xs={12} sm={4} md={6} key={req?.id}>
              <Link to={`/req/view-bids/${id}`} state={{ req }}>
                <DestReqCardIndex reqData={req} itemId={id} />
              </Link>
            </Grid>
          );
        })}
      </Grid>

      {/* <Fab
        variant="extended"
        color="primary"
        href={"/post-req"}
        sx={{ position: "fixed", bottom: isMobile ? 105 : 60, right: isMobile ? 85 : 90 }}
      >
        <NavigationIcon sx={{ mr: 1 }} />
        Post Req
      </Fab> */}
    </>
  );
};

export default AdminReqView;
